/**
 * @summary     app.localCache.js
 * @description App JS Local Cache Controller
 * @version     1.5
 	> 1.0 Initial version
  		- 01/13/2016 SG
	> 1.1 Added encoding keys and data feature to obfuscate originating data
		- 01/19/2016 SG
	> 1.2 Fixed an issue with some characters not being able to be encrypted
 		- 03/02/2016 SG
	> 1.3 Fixed issue with remove method not encoding keys
		- 08/01/2016 SG
	> 1.4 Fixed issue with private browsers that disallow localStorage
		- 08/26/2016 SG
	> 1.5 Fixed issue with setting item too large for local cache
		- 09/14/2017 SG
 * @file        app.localCache.js
 * @author      Silas Garrison (http://silasgarrison.com/)
 *
 * This source file is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 *
 ** EXAMPLES:
 ** NOTE:
 	This extrapolates use of local and session storage in browsers but has a fail safe in case they don't work
 ** TODO:
*/

app.addFeature(
	"localCache",
	function(){
		"use strict";

		var filler = function(){
				var store = {};

				return {
					getItem : function(key){
						return store[key] === undefined?null:store[key];
					},
					setItem : function(key,value){
						store[key] = value;
					},
					removeItem : function(key){
						delete store[key];
					}
				};
			},
			scopes = {
				"session" : (
					function(){
						try {
							window.sessionStorage.setItem("__test__",1);
							return window.sessionStorage;
						}
						catch(e){
							return filler();
						}
					}
				)(),
				"local" : (
					function(){
						try {
							window.localStorage.setItem("__test__",1);
							return window.localStorage;
						}
						catch(e){
							return filler();
						}
					}
				)()
			},
			defaultScope = "local",
			encodeKeys = false,
			encodeData = false;

		/*
			Name: encode
			Use: PRIVATE.encode()
			Args: str String - String to encode
					doEncode Boolean - Flag from either encodeKeys or encodeData as to whether the value should be encoded
			Description: Encodes a string if the features are enabled
		*/
		function encode(str,doEncode){
			if(window.btoa && window.atob && doEncode){
				try {
					return window.btoa(str);
				}
				catch(e){
					// TODO: Proper error handling
					console.log("Failed to encode: " + JSON.stringify(e));
				}
			}

			return str;
		}

		/*
			Name: decode
			Use: PRIVATE.decode()
			Args: str String - String to encode
					doEncode Boolean - Flag from either encodeKeys or encodeData as to whether the value should be encoded
			Description: Decodes a string if the features are enabled
		*/
		function decode(str,doEncode){
			if(window.btoa && window.atob && doEncode){
				try {
					return window.atob(str);
				}
				catch(e){
					// TODO: Proper error handling
					console.log("Failed to decode: " + JSON.stringify(e));
				}
			}

			return str;
		}

		/*
			Name: setDefaulScope
			Use: API.setDefaulScope()
			Args: scope String - New scope (local or session) to be the default
			Description: Sets the default scope from which getters and settings will work
		*/
		this.setDefaulScope = function(scope){
			defaultScope = scope;
		};

		/*
			Name: get
			Use: API.get()
			Args: item String - The item to retrieve from cache
					scope String - The scope from which cache to pull from
			Description: Gets an item's value from local cache
		*/
		this.get = function(item,scope){
			var value = scopes[scope || defaultScope].getItem(encode(item,encodeKeys));

			// If it's not null then we've found a value - try and parse it in case it's a valid JSON object
			if(value !== null){
				try {
					value = JSON.parse(decode(value,encodeData));
				}
				catch(e){
					// TODO: Proper error handling
					value = decode(value,encodeData);
				}
			}

			return value;
		};

		/*
			Name: set
			Use: API.set()
			Args: item String - String that represents the key or ID of this item
					value Any - The value that needs to be cached
					scope String - Scope to use when setting cache
			Description: Sets a new key/value pair into cache
		*/
		this.set = function(item,value,scope){
			// If they've not passed in a string, then try and stringify it now so that we can easily store JSON objects
			if(typeof value !== "string"){
				try {
					value = JSON.stringify(value);
				}
				catch(e){
					// TODO: Proper error handling
				}
			}

			try {
				scopes[scope || defaultScope].setItem(
					encode(item,encodeKeys),
					encode(value,encodeData)
				);
			}
			catch(e){
				console.log('Error Setting Cache: ',e);
			}
		};

		/*
			Name: setEncodeKeys
			Use: API.setEncodeKeys()
			Args: value Boolean - Value to set the flag to
			Description: Updates the encodeKeys flag
		*/
		this.setEncodeKeys = function(value){
			encodeKeys = typeof value === "boolean"?value:encodeKeys;
			return this;
		};

		/*
			Name: setEncodeData
			Use: API.setEncodeData()
			Args: value Boolean - Value to set the flag to
			Description: Updates the encodeData flag
		*/
		this.setEncodeData = function(value){
			encodeData = typeof value === "boolean"?value:encodeData;
			return this;
		};

		/*
			Name: remove
			Use: API.remove()
			Args: item String - String that represents the key or ID of this item
					scope String - Scope to use when setting cache
			Description: Removes an item from cache
		*/
		this.remove = function(item,scope){
			scopes[scope || defaultScope].removeItem(encode(item,encodeKeys));
			return this;
		};

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: Initializes the controller
		*/
		this.init = function(){
			return this;
		};
	}
);
